/*! Twire forms - MIT license  */
export default {
	
	// Add data-twire-form-alert="true" to alert errors
	// data-twire-after-failed-validation-function (just a function where you can do as you wish)
	// data-twire-after-validation-function, e.g.:
	//window.fooBar = function($form) {

		// If error call twire.forms.addValidationHandler($form);

		// If successful call twire.forms.submitValidatedForm($form);
		
		// Browsers tend to reload form values if you press the back button
		// Because PW always uses session most, if not all, browsers seem to re-generate the GUID
		// If you don't want the form to be filled out again after submitted you can use either of the following:
		// $form.addClass('twire-form-submitting'); // Disable the form if back button is pressed, optional
		// $form.remove(); // Remove the form from the DOM

	//}
	addValidationHandler: function($form = null) {
		
		var _self = this;
		
		// If no $form is passed then apply to all (used when setting the page up)
		// When running post validation hooks $form should be passed forms don't
		// end up with multipler handlers running
		$form = $form === null ? $('form.twire-validated-form') : $form;

		$form.on('submit.twire.twire-forms', function(e) {

			// Cache
			var $this = $(this);

			if ($this.hasClass('twire-form-submitting') === false) {

				$this.addClass('twire-form-submitting');
				
				$this.find('div.twire-form-error').remove();

				$.post('/twire/api/validate-form/' + encodeURIComponent($this.data('twire-form-name')), $this.serialize(), 'json')
				 .done(function(response) {
					 
					console.log(response);

					$this.removeClass('twire-form-submitting');

					if (response.passed === false) {
						
						var alertText 	= '';
						var alertErrors = false;
						
						if ($this.data('twire-form-alert') === 'true' || $this.data('twire-form-alert') === true) {

							alertErrors = true;

						}
							
						$.each(response.errors, function(key, value) {
							
							// Summary is string, rest are array
							if (key == '_summary') {
								
								alertText += value;
								alertText += "\n";
								
								if (alertErrors === false) {
								
									$this.find('.twire-_summary').find('div.twire-form-error-parent').prepend('<div class="twire-form-error"></div>');
									$this.find('.twire-_summary').find('div.twire-form-error-parent').find('div.twire-form-error').text(errors);
									
								}
								
							} else if (value.length > 0) {
							
								var errors = value.join("\n");

								alertText += errors;
								alertText += "\n";
								
								if (alertErrors === false) {
								
									$this.find('.twire-' + $.escapeSelector(key)).find('div.twire-form-error-parent').prepend('<div class="twire-form-error"></div>');
									$this.find('.twire-' + $.escapeSelector(key)).find('div.twire-form-error-parent').find('div.twire-form-error').text(errors);
									
								}
								
							}
							
						});
						
						if (alertErrors === true) {
							
							alert(alertText);
							
						}

						// Check to see if there's a function to call after validation fails
						if ($this.data('twire-after-failed-validation-function')) {

							window[$this.data('twire-after-failed-validation-function')]($this);

						}
						
					} else {
						
						// Remove errors, handler and submit; the handler needs removing to prevent an infinite loop
						// Seeing as PW always uses sessions this likely isn't used but keep it here just in case
						$this.removeClass('twire-form-error')
						     .off('submit');

						// Check to see if there's a function to call afterward
						if ($this.data('twire-after-validation-function')) {

							// If so, call this, it is then the responsbility of this function to call _self.submitValidatedForm()
							window[$this.data('twire-after-validation-function')]($this);

						} else {

							// Submits the form and re-adds the handler
							_self.submitValidatedForm($this);

						}
						
					}

				}).fail(function(jqXHR, textStatus, errorThrown) {
					
					console.log(jqXHR);

					$this.removeClass('twire-form-submitting')
					     .addClass('twire-form-failed');
						 
					alert('The form encountered a server error');

				});

				e.preventDefault();

			} else {

				return true;

			}

		});
		
	},
	submitValidatedForm: function($form) {
		
		var _self = this;

		// Submit the form
		$form.find('button[type="submit"]')
			 .trigger('click');

		 // Re-add now in case the back button is clicked
		 _self.addValidationHandler($form);

	}
	
};
